// Ported verbatim from NearpodNext's `src/helpers/math/mathSpeech.js`.
//
// After MathJax 4 typesets a formula, it leaves the human-readable speech text in a
// `data-semantic-speech-none` attribute on the <mjx-container> (the `-none` variant is plain
// text; the plain `data-semantic-speech` is SSML and must not be used here). The container's
// own textContent is glyph soup, so the walk emits that attribute and does NOT descend into it.

const MATH_SPEECH_ATTRIBUTE = 'data-semantic-speech-none'

const isMathContainer = (node: Element): boolean =>
	node.tagName?.toLowerCase() === 'mjx-container' || node.hasAttribute(MATH_SPEECH_ATTRIBUTE)

const collectSpeech = (node: Node, pieces: string[]) => {
	if (node.nodeType === Node.TEXT_NODE) {
		pieces.push(node.nodeValue || '')
		return
	}
	if (node.nodeType !== Node.ELEMENT_NODE) return
	const element = node as Element
	if (isMathContainer(element)) {
		pieces.push(element.getAttribute(MATH_SPEECH_ATTRIBUTE) || '')
		return
	}
	element.childNodes.forEach((child) => collectSpeech(child, pieces))
}

const extractMathSpeech = (element: HTMLElement | null): string => {
	if (!element) return ''
	const pieces: string[] = []
	collectSpeech(element, pieces)
	return pieces.join(' ').replace(/\s+/g, ' ').trim()
}

export { extractMathSpeech }
